module.exports = __webpack_public_path__ + "static/img/follow_img.3ad81e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/follow_img.png
// module id = DB/Z
// module chunks = 0